<template>
  <div>
    <a-spin :spinning="loading">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">
            <strong>Add details</strong>
          </h5>
          <a-row>
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
              <a-form-model ref="ruleForm" :model="form" :rules="rules">
                <a-form-model-item
                  ref="userName"
                  prop="userName"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Username (email)"
                  @blur="
                    () => {
                      $refs.userName.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.userName" />
                </a-form-model-item>
                <a-form-model-item
                  ref="firstName"
                  prop="firstName"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="First name"
                  @blur="
                    () => {
                      $refs.firstName.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.firstName" />
                </a-form-model-item>

                <a-form-model-item
                  ref="lastName"
                  prop="lastName"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Last name"
                  @blur="
                    () => {
                      $refs.lastName.onFieldBlur()
                    }
                  "
                >
                  <a-input v-model="form.lastName" />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Display name"
                >
                  <a-input
                    v-model="displayName"
                    disabled
                    style="background-color: white !important; color: black;"
                  />
                </a-form-model-item>

                <a-form-model-item
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label="Participant"
                >
                  <a-select
                    show-search
                    option-filter-prop="children"
                    allowClear
                    style="width: 100%;"
                    :filter-option="filterOption"
                    :value="
                      form.participant == null ? undefined : form.participant
                    "
                    @change="handleChangeParticipant"
                  >
                    <a-select-option
                      v-if="isEdit"
                      :key="currentUser.participant.id"
                      :value="currentUser.participant.id"
                    >
                      {{ currentUser.participant.name }}
                    </a-select-option>
                    <a-select-option
                      v-for="participant in unallocatedParticipants"
                      :key="participant.id"
                      :value="participant.id"
                      >{{ participant.name }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
                <div class="float-right">
                  <a-space :space="16">
                    <a-button
                      v-if="isEdit"
                      @click="resendActivationEmail"
                      class=""
                      type="default"
                    >
                      Resend activation email
                    </a-button>

                    <a-button
                      v-if="isEdit"
                      @click="resetPassword"
                      class=""
                      type="danger"
                    >
                      Reset password
                    </a-button>

                    <a-button @click="onSubmit" class="btn btn-success">
                      Save
                    </a-button>
                  </a-space>
                </div>
              </a-form-model>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import { Space, Button, Row, Col } from 'ant-design-vue'
Vue.use(Space)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
import { UserService, ParticipantService } from '@/services/api'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 20 },
}

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      labelCol,
      wrapperCol,
      loading: true,
      currentUser: {
        participant: {
          name: '',
        },
      },
      allParticipants: [],
      rules: {
        firstName: [
          {
            required: true,
            message: 'Please input First name',
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Please input Last name',
            trigger: 'blur',
          },
        ],
        userName: [
          {
            required: true,
            message: 'Please input Username (email address)',
            trigger: 'blur',
          },
        ],
      },
      form: {
        firstName: '',
        lastName: '',
        userName: '',
        participant: null,
      },
    }
  },
  methods: {
    handleChangeParticipant(value) {
      this.form.participant = value
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    resendActivationEmail() {
      UserService.resendActivation(this.$route.params.id)
        .then((response) => {
          this.$notification.success({
            message: 'Action successful',
            description: `Activation email sent to user.`,
          })
        })
        .catch((error) => {
          this.$notification.error({
            message: 'Action failed',
            description: `Activation email sending failed. Please try again.`,
          })
        })
    },
    resetPassword() {
      UserService.resetPassword(this.$route.params.id)
        .then((response) => {
          this.$notification.success({
            message: 'Reset password',
            description: `Password reset initiated successfully.`,
          })
        })
        .catch((error) => {
          this.$notification.error({
            message: 'Reset password',
            description: `Failed to initiate password reset. Please try again.`,
          })
        })
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true

          if (this.form.participant == undefined) {
            this.form.participant = null
          }

          var dataToSend = {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            username: this.form.userName,
            participant: this.form.participant,
          }
          if (this.isEdit) {
            UserService.update(this.$route.params.id, dataToSend).then(
              (response) => {
                this.$notification.success({
                  message: 'User update',
                  description: `User details have been updated successfully.`,
                })
                this.getData()
              }
            )
          } else {
            UserService.save(dataToSend).then((response) => {
              // console.log(response.data.data)
              // this.dataSource = response.data.data
              this.$notification.success({
                message: 'User added',
                description: `New user has been added successfully.`,
              })
              this.$router.push('/users')
              // this.loading = false
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getData() {
      UserService.get(this.$route.params.id).then((response) => {
        this.currentUser = response.data.data
        this.form.firstName = response.data.data.firstName
        this.form.lastName = response.data.data.lastName
        this.form.userName = response.data.data.username
        this.form.participant = response.data.data.participant
          ? response.data.data.participant.id
          : null
        this.loading = false
      })
    },
    getParticipants() {
      ParticipantService.get().then((response) => {
        this.allParticipants = response.data.data
      })
    },
  },
  watch: {
    isEdit: function (val) {
      if (!val) {
        this.form.firstName = ''
        this.form.lastName = ''
        this.form.userName = ''
        this.form.participant = null
      }
    },
  },
  computed: {
    // a computed getter
    unallocatedParticipants: function () {
      return this.allParticipants.filter(
        (participant) => participant.user == null
      )
    },
    displayName: function () {
      // `this` points to the vm instance
      return this.form.firstName + ' ' + this.form.lastName
    },
  },
  mounted() {
    this.getParticipants()
    if (this.isEdit) {
      this.getData()
    } else {
      this.loading = false
    }
  },
}
</script>
